var UserAPI = require('../../common/api/user');
var auth = require('../auth');

module.exports = function($scope, ngDialog) {
	var vm = this;
	vm.profile = {};
	vm.profilePicture = {};
	vm.error = '';

	vm.init = function() {
		if (
			ngDialog.getOpenDialogs().length == 0 &&
			!auth.hasClaims([{ type: 'gdpr_questions_completed', value: null }])
		) {
			vm.openGDPRDialog();
		}

		UserAPI.GetFundraisingProfiles(
			null,
			'FundraiserApplicationSummaryView'
		).then(function(result) {
			vm.supported = result;
			vm.supported.forEach(function(item) {
				var perc = Math.floor(
					item.grandTotalRaised /
						(item.totalRequested + item.totalExternallyRaised) *
						100
				);
				if (perc > 100) {
					item.percentage = 100;
				} else if (perc <= 0) {
					item.percentage = 0;
				} else {
					item.percentage = perc;
				}
			});
		});
		vm.getProfile();
	};

	vm.getProfile = function() {
		return UserAPI.GetProfile().then(function(result) {
			if (result) {
				vm.profile = result;
			} else {
				return UserAPI.CreateProfile(vm.profile).then(function() {
					return vm.init();
				});
			}
		});
	};

	vm.openGDPRDialog = function() {
		var dialog = ngDialog
			.openConfirm({
				template: require('./dialogs/gdpr.pug')(),
				controller: require('./dialogs/gdpr'),
				controllerAs: 'vm',
				plain: true,
				disableAnimation: true,
				className: 'ge-dialog-medium ngdialog-theme-default',
				showClose: false,
				closeByEscape: false,
				closeByNavigation: false,
				closeByDocument: false
			})
			.then(function(req) {
				var answers = Object.keys(req.answers).map(function(key) {
					return { QuestionId: key, Answer: req.answers[key] };
				});

				UserAPI.UpdateGdprQuestions(answers).then(function() {
					auth.refresh();
					vm.getProfile();
				});
			});
	};

	vm.submit = function(request) {
		request = angular.copy(request);
		request.userId = vm.profile.userId;
		request.id = vm.profile.profileId;
		vm.profile = request;
		if (vm.profile.id) {
			return UserAPI.UpdateProfile(vm.profile).then(function() {
				return vm.init();
			});
		} else {
			return UserAPI.CreateProfile(vm.profile).then(function() {
				return vm.init();
			});
		}
	};

	vm.submitQuestion = function(request) {
		var profile = angular.copy(vm.profile);
		var q = request.q;

		var oldQ = profile.gdprAnswers.find(function(item) {
			return item.questionId == q.questionId;
		});

		oldQ.answer = q.answer;

		return vm.submit(profile);
	};

	vm.submitProfilePicture = function() {
		if (Array.isArray(vm.profile.profilePicture)) {
			vm.profile.lowQualityProfilePicture = vm.profile.profilePicture[1];
			vm.profile.profilePicture = vm.profile.profilePicture[0];
		}

		return vm.submit(vm.profile);
	};

	vm.emailController = function($emailScope) {
		$emailScope.remove = function($event) {
			$event.preventDefault();
			$emailScope.request.remove = true;
			$emailScope.submit();
		};
	};

	vm.updateEmail = function(request) {
		if (request.remove) {
			vm.removeEmail();
		} else {
			const email =
				request.newEmail !== null ? request.newEmail : request.email;
			return UserAPI.UpdateEmail(vm.profile.userId, email)
				.then(function(response) {
					return vm.init();
				})
				.catch(function(response) {
					if (
						!!~response.text.indexOf('Email address already in use')
					) {
						throw new Error('Email is already in use');
						return;
					}
					throw response;
				});
		}
	};

	vm.removeEmail = function() {
		return UserAPI.RemoveEmail(vm.profile.userId).then(function(response) {
			return vm.init();
		});
	};

	vm.init();

	vm.initQuestionForm = function(question) {
		return Promise.resolve({ q: question });
	};
};
